<template>
  <div>
    <div
      class="cardLayoutWrapper"
      v-if="item"
    >
      <BasicCellActionIcon
        :span="1"
        icon-name="document-text"
        :deactivated="!item.estSousMandatGestion"
        :hover-messages="{ actif: 'Avec mandat de gestion', inactif: 'Sans mandat de gestion' }"
        :is-readonly="true"
      />
      <BasicCellActionIcon
        :span="1"
        icon-name="wallet"
        :deactivated="!item.avecSubrogation"
        :hover-messages="{ actif: 'Avec subrogation', inactif: 'Sans subrogation' }"
        :is-readonly="true"
      />
      <BasicCellActionIcon
        :span="1"
        icon-name="profile-circle"
        :deactivated="!estProprietaire"
        :hover-messages="{ actif: 'Mon brouillon', inactif: '' }"
        :is-readonly="true"
      />
      <BasicCell
        :span="3"
        :text="item?.id"
        lines="1"
        @click="ouvrirDemande(item)"
      />
      <BasicCell
        :span="12"
        :text="item?.sousDispositif ? SousDispositifLibelle[item?.sousDispositif as SousDispositif] : ''"
        lines="1"
      />
      <BasicCell
        :span="9"
        :text="item?.adherent?.denomination"
        lines="1"
      />
      <BasicCell :span="5">
        <BasicTooltip :label="StatutLibelle[item.statut]">
          <BasicBadge
            :type="explicitCast(StatutBadgeType[item.statut])"
            :deletable="false"
            :label="StatutLibelle[item.statut]"
          />
        </BasicTooltip>
      </BasicCell>
      <BasicCell
        :span="4"
        right
        extra-class="elem--row"
      >
        <BasicCellActionIcon
          :icon-name="readonly ? 'eye' : 'edit'"
          :hover-messages="{ actif: readonly ? 'Voir la demande' : 'Modifier la demande' }"
          @click="() => ouvrirDemande(item)"
        />
        <BasicCellActionIcon
          v-if="checkClonePermission(item.dispositif)"
          icon-name="duplicate"
          :hover-messages="{ actif: 'Dupliquer la demande' }"
          @click="clickClone"
        />
        <BasicCellActionIcon
          v-if="deletable"
          icon-name="trash"
          :hover-messages="{ actif: 'Supprimer la demande' }"
          @click="() => deleteDemande(item.id)"
        />
      </BasicCell>
    </div>
    <Transition name="open">
      <div
        v-if="showDrawer && (stagiairesList.length || prestatairesList.length)"
        class="listDrawerWrapper"
      >
        <div class="content">
          <ListDetails>
            <template #content>
              <div
                class="listDetailsElement"
                v-if="stagiairesList.length"
              >
                <span class="listDetailsTitle">Stagiaire(s)</span>
                <span class="listDetailsSubtitle">
                  {{ stagiairesList }}
                </span>
              </div>
              <div
                class="listDetailsElement"
                v-if="prestatairesList.length"
              >
                <span class="listDetailsTitle">Organisme(s)</span>
                <span
                  class="listDetailsSubtitle"
                  v-for="item in prestatairesList"
                  :key="item"
                >
                  {{ item }}
                </span>
              </div>
            </template>
          </ListDetails>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
  import type { RechercheResultDTO } from '@/features/api/extranet/dto/Demande/Recherche'
  import { StatutBadgeType, StatutLibelle } from '@/features/domaine/types/opco'
  import { SousDispositif, SousDispositifLibelle } from '@/features/domaine/types/opco/Demande/OUTILFPE'
  import { explicitCast } from '@/features/interface/shared/tools'
  import BasicCell from '@designSystem/components/basic/cell/BasicCell.vue'
  import BasicCellActionIcon from '@designSystem/components/basic/cell/BasicCellActionIcon.vue'
  import { computed, ref } from 'vue'
  import { useDemandeTtHelper } from '../useDemandeHelper'
  import { useRechercheDemandeTTActions } from '../useRechercheDemandeTTActions.ts'
  import ListDetails from './ListDetails.vue'

  const { cloneDemande, deleteDemande, ouvrirDemande } = useRechercheDemandeTTActions()

  const props = defineProps<{ item: RechercheResultDTO }>()
  const { readonly, stagiairesList, prestatairesList, checkClonePermission, deletable } = useDemandeTtHelper(
    props.item,
  )
  const estProprietaire = computed(() => !!props.item?.estProprietaire)
  const showDrawer = ref(false)

  const clickClone = () => {
    return cloneDemande({
      dispositif: props.item.dispositif,
      idDemande: props.item.id,
      idcc: props.item.adherent.idcc!.code,
      siret: props.item.adherent.siret.valeur!,
      permissions: props.item.niveauPermission,
      sousDispositif: props.item.sousDispositif,
      codeDrf: null
    })
  }
</script>

<style scoped>
  @import '../../index.less';
</style>
